'use client';

import { Header } from '@/components';
import Footer from '@/components/footer/Footer';
import { useThemeMode } from '@/context';
import { getContainerStyles } from '@/utils';
import { css } from '@emotion/react';
import {
  FlexItem,
  FlexLayout,
  Typography,
  Image,
  Container,
  Button,
  useTheme,
  responsive,
  Icon,
} from '@wci-tech/core-ui';

import { BsArrowUpRight } from 'react-icons/bs';
import { useTranslations } from 'next-intl';

const Error = () => {
  const { theme } = useTheme();
  const { isDark } = useThemeMode();

  const t = useTranslations('Error');

  const containerStyles = css`
    ${getContainerStyles(theme)};
    ${responsive.create({
      paddingTop: {
        default: theme.spacing.get(56),
        md: theme.spacing.get(44),
        lg: theme.spacing.get(116),
      },
      paddingBottom: {
        default: theme.spacing.get(52),
        md: theme.spacing.get(44),
        lg: theme.spacing.get(116),
      },
    })}
  `;

  const errorTextStyles = css`
    color: ${isDark ? theme.colors.commonColors.white : '#212121'};
    font-weight: ${theme.fonts.weight.medium};

    ${responsive.create({
      fontSize: {
        default: theme.fonts.size.xxl,
        md: theme.fonts.size['5xl'],
        lg: theme.fonts.size['6xl'],
      },
    })}
  `;

  return (
    <>
      <Header showNavbar={false} disableScrollEffect />
      <main>
        <Container customStyles={containerStyles}>
          <FlexLayout
            alignItems={'center'}
            justifyContent={'center'}
            direction={'column'}
            padding={{ default: 0 }}
            gap={{ default: 10, md: 18, lg: 24 }}
          >
            <FlexItem>
              <Image
                isImgDecorative={true}
                altText={t('imageAlt')}
                src="/images/SomethingWengWrongMobile.png"
                priority={true}
                fetchPriority="high"
                preload={true}
                loading="eager"
                objectFit="contain"
                width={{
                  default: 288,
                  md: 554,
                  lg: 708,
                }}
                height={{
                  default: 248,
                  md: 148,
                  lg: 362,
                }}
                sizes="(max-width: 767px) 288px, (max-width: 1023px) 554px, 708px"
                sources={[
                  {
                    srcSet: '/images/SomethingWengWrongDesktop.png',
                    media: '(min-width: 1024px)',
                    type: 'image/png',
                  },
                  {
                    srcSet: '/images/SomethingWengWrongTablet.png',
                    media: '(min-width: 768px)',
                    type: 'image/png',
                  },
                ]}
              />
            </FlexItem>
            <FlexItem>
              <Typography variant="h1" customStyles={errorTextStyles}>
                {t('title')}
              </Typography>
            </FlexItem>
            <FlexItem>
              <Button
                appearance="outline"
                variant={isDark ? 'secondary' : 'primary'}
                effect="liquid-fill"
                icon={
                  <Icon
                    name={BsArrowUpRight}
                    size={{
                      default: '14px',
                      lg: '16px',
                    }}
                  />
                }
                iconPlacement="right"
                shape="pill"
                href="/"
                customStyles={{
                  icon: {
                    right: css`
                      svg {
                        stroke-width: 0.6;
                      }
                    `,
                  },
                }}
              >
                {t('button')}
              </Button>
            </FlexItem>
          </FlexLayout>
        </Container>
      </main>
      <Footer />
    </>
  );
};

export default Error;
